import { useConfig } from "../Providers/ConfigProvider";
import { useState } from "react";

const useGetProductImage = () => {
    const { dataUrl } = useConfig()

    const GetProductImage = ({ photoFileName, imgClassName = '' }) => {
        const [visible, setVisible] = useState(true)
        var src = `${dataUrl}/miniaturki/${photoFileName}`

        const handleError = () => {
            setVisible(false)
        }

        if (!photoFileName || photoFileName.trim() === '') {
            return <div style={{ color: 'transparent', backgroundColor: 'transparent' }} className={imgClassName} />
        }
        if (!visible) {
            return <div style={{ color: 'transparent', backgroundColor: 'transparent' }} className={imgClassName} />
        }
        return <img src={src} onError={handleError} alt="" className={imgClassName} />

    }

    return { GetProductImage }
}

export default useGetProductImage